<template>
    <footer class="footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6">
                    {{ year }} © HAXO - Le contrôle d'accès connecté
                </div>
                <div class="col-md-6">
                    <div class="text-md-end footer-links d-none d-md-block">
                        <div class="position-absolute start-50 translate-middle-x">
                            Dernière mise à jour : {{ buildDate }}
                        </div>
                        <a href="https://haxo.tech" target="_blank">À propos</a>
                        <!-- <a href="javascript: void(0);">Nous contacter</a> -->
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import moment from 'moment';

export default {
    name: 'FooterBar',
    computed: {
        year() {
            return new Date().getFullYear();
        },
        buildDate() {
            return moment(process.env.VUE_APP_BUILD_DATE).local().format('DD/MM/YYYY HH:mm:ss');
        }
    }
}

</script>
